import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InvoiceTableRow from './InvoiceTableRow';
import InquiryQuickview from './InquiryQuickview';
import { get, post } from 'axios';
import { isEmpty, noop } from '../../utils';
import Modal from 'react-bootstrap4-modal';
import ModalInvoicePayment from './ModalInvoicePayment';
import ModalInvoiceView from './ModalInvoiceView';
import Notifications, {notify} from 'react-notify-toast';
import PerfectScrollbar from 'react-perfect-scrollbar';
import BookingInvoice from './BookingInvoice';
import 'react-perfect-scrollbar/dist/css/styles.css';


@inject('userStore')
class Invoices extends Component {
    constructor(props){
        super(props);
        this.state = {
            original_list:[],
            invoice_list: [],
            visible:false,
            modalTitle:'Test Title',
            component:null,
            invoice:null,
            quickviewInvoice:null,
            invoiceComponent:null,
            activeTab:'unpaid',
            quickviewVisible:false,
            searchValue:'',
            payment_type_list:[],
            printing:false
        }
        this.fetchInvoices = this.fetchInvoices.bind(this);
        this.modalBackgroundClicked = this.modalBackgroundClicked.bind(this);
        this.modalHandler = this.modalHandler.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.quickviewHandler = this.quickviewHandler.bind(this);
        this.reloadHandler = this.reloadHandler.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.sortByPublish = this.sortByPublish.bind(this);
        this.sortByCreate = this.sortByCreate.bind(this);
        this.sortByAmount = this.sortByAmount.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.sendPaymentRequest = this.sendPaymentRequest.bind(this);
        this.printInvoice = this.printInvoice.bind(this);
        this.publishHandler = this.publishHandler.bind(this);
        this.invoiceHandler = this.invoiceHandler.bind(this);
        this.back = this.back.bind(this);
    }


    componentDidMount() {
        this.fetchInvoices();
    }

    setActiveTab(tab){
        this.setState({
            activeTab:tab
        })
    }

    valueChange(event){
        this.setState({searchValue: event.target.value}, () => {
            // filter the array
            this.setState({
                invoice_list:this.state.original_list
            }, () => {
                if (this.state.searchValue.length > 2){
                    var searchList = this.state.invoice_list.filter((invoice) =>
                        invoice.booking.email.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        invoice.booking.full_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        invoice.booking.event_name.toLowerCase().includes(this.state.searchValue.toLowerCase())
                    );
                    this.setState({
                        invoice_list:searchList
                    });
                }
            })
        });
    }

    quickviewHandler(invoice){
      post('/v2/get/invoice', {bk_invoice_hash_id: invoice.hash_id}, {
          auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.invoice){
          this.setState({
            invoice:res.data.invoice,
            quickviewVisible:true
          })
        }
      }).catch((error) => {
        console.log(error);
        return error;
      });      
    }

    clearSearch(){
        this.setState({
            searchValue:'',
            invoice_list:this.state.original_list
        })
    }

    sortBy(sortType){
        switch (sortType) {
            case 'PUBLISH':
                this.setState({
                    invoice_list:this.state.invoice_list.sort(this.sortByPublish)
                })
                break;
            case 'CREATE':
                this.setState({
                    invoice_list:this.state.invoice_list.sort(this.sortByCreate)
                })
                break;
            case 'AMOUNT':
                this.setState({
                    invoice_list:this.state.invoice_list.sort(this.sortByAmount)
                })
                break;
            default:

        }
    }

    sortByPublish(a,b) {
        if (a.publish_date < b.publish_date)
            return -1;
        if (a.publish_date > b.publish_date)
            return 1;
        return 0;
    }

    sortByCreate(a,b) {
        if (a.days_since < b.days_since)
            return -1;
        if (a.days_since > b.days_since)
            return 1;
        return 0;
    }

    sortByAmount(a,b) {
        if (a.due_amount > b.due_amount)
            return -1;
        if (a.due_amount < b.due_amount)
            return 1;
        return 0;
    }

    modalBackgroundClicked(invoice){
        this.setState({
            visible:!this.state.visible, component:null
        });
    }

    modalHandler(invoice, component, title){
        this.setState({
            invoice:invoice,
            component:component,
            visible:!this.state.visible,
            modalTitle:title
        })
    }

    closeHandler(){
        this.setState({
            quickviewVisible:false
        })
    }

    reloadHandler(updated_invoice){
        let temp_invoice_list = this.state.invoice_list;
        let index = this.state.invoice_list.findIndex(x => x.id === updated_invoice.id);
        temp_invoice_list[index] = updated_invoice;
        this.setState({
            invoice_list:temp_invoice_list,
            invoice:null,
            visible:false,
            quickviewVisible:false
        })
    }

    back(){
        this.setState({
            invoiceComponent:null
        })
    }

    selectInvoiceByHash = (hash_id) => {
      let index = this.state.invoice_list.findIndex(x => x.hash_id === hash_id);
      let invoice = this.state.invoice_list[index];
      this.quickviewHandler(invoice);
    }


    invoiceHandler(invoice){
        this.setState({
            quickviewVisible:false,
            invoiceComponent:<BookingInvoice backHandler={this.back} booking={invoice.booking} invoice={invoice}/>
        })
    }

    fetchInvoices(){
        post('v2/get/invoice_list_all', {
                business_hash_id: this.props.userStore.business_primary.hash_id
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              this.setState({
                  invoice_list:res.data.invoice_list,
                  original_list:res.data.invoice_list,
                  payment_type_list:res.data.payment_type_list
              },()=>{
                if (this.props.location.state && this.props.location.state.hash_id){
                  this.selectInvoiceByHash(this.props.location.state.hash_id)
                }
              });
          }).catch((error) => {
                return error;
          });
    }

    sendPaymentRequest(invoice){
        post('/v2/send/payment_request', {hash_id: invoice.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                notify.show(res.data.message, "success", 4000);
            } else {
                notify.show(res.data.message, "danger", 4000);
            }
        }).catch((error) => {
            notify.show(error, "danger", 4000);
            return error;
        });
    }


    printInvoice(invoice){
        this.setState({
            printing:true
        }, ()=>{
            post('/v2/print/invoice', {hash_id: invoice.hash_id},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    // set interval to check status
                    var doc_id = res.data.id;
                    var notify = notify;
                    this.interval = setInterval(()=>{
                        post('/v2/print/is_generated', {id: doc_id},{
                        }).then((res) => {
                            if (res.data.completed === 1){
                                window.open(res.data.file);
                                clearInterval(this.interval);
                                this.setState({printing:false});
                            }
                        }).catch((error) => {
                            notify.show(error, "danger", 4000);
                            this.setState({printing:false});
                            return error;
                        });
                    }, 3000);
                } else {
                    notify.show(res.data.message, "danger", 4000);
                    this.setState({printing:false});
                }
            }).catch((error) => {
                notify.show(error, "danger", 4000);
                this.setState({printing:false});
                return error;
            });
        });
    }

    publishHandler(invoice){
        invoice.is_published = !invoice.is_published;
        let publish = 0;
        if (invoice.is_published){
            publish = 1;
        }
        // save this
        post('v2/save/invoice_publish', {
                invoice_hash_id: invoice.hash_id,
                is_published: publish
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              this.reloadHandler(res.data.invoice);
              notify.show(res.data.message, "success", 4000);
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }


  render() {
      const { invoice_list, original_list, invoice } = this.state;

      var activeTabComponent = null;
      switch (this.state.activeTab) {
          case "unpaid":
              activeTabComponent = (
                  <div id="unpaid" className="tab-pane active media-list media-list-divided media-list-hover" data-provide="selectall">
                      <table style={{width:100+"%"}}>
                          <tbody className="media-list-body bg-white b-1">
                          {invoice_list.map((inv, invoice_index) => {
                              if (!inv.is_paid && inv.is_published){
                                  return (<InvoiceTableRow invoice={inv} key={invoice_index} qHandler={this.quickviewHandler} handler={this.modalHandler} notifyHandler={notify} sendHandler={this.sendPaymentRequest} publishHandler={this.publishHandler} invoiceHandler={this.invoiceHandler}/>);
                              }
                          }
                          )}
                          </tbody>
                      </table>
                  </div>
              );
              break;
          case "unpublished":
              activeTabComponent = (
                  <div id="paid" className="tab-pane active media-list media-list-divided media-list-hover" data-provide="selectall">
                      <table className="media-list-body bg-white b-1" style={{width:100+"%"}}>
                          <tbody className="media-list-body bg-white b-1">
                          {invoice_list.map((inv, invoice_index) => {
                              if (!inv.is_published && !inv.is_paid){
                                  return (<InvoiceTableRow invoice={inv} key={invoice_index} qHandler={this.quickviewHandler} handler={this.modalHandler} notifyHandler={notify} sendHandler={this.sendPaymentRequest} publishHandler={this.publishHandler} invoiceHandler={this.invoiceHandler}/>);
                              }
                          }
                          )}
                          </tbody>
                      </table>
                  </div>
              );
              break;
          case "paid":
              activeTabComponent = (
                  <div id="paid" className="tab-pane active media-list media-list-divided media-list-hover" data-provide="selectall">
                      <table className="media-list-body bg-white b-1" style={{width:100+"%"}}>
                          <tbody className="media-list-body bg-white b-1">
                          {invoice_list.map((inv, invoice_index) => {
                              if (inv.is_paid){
                                  return (<InvoiceTableRow invoice={inv} key={invoice_index} qHandler={this.quickviewHandler} handler={this.modalHandler} notifyHandler={notify} sendHandler={this.sendPaymentRequest} publishHandler={this.publishHandler} invoiceHandler={this.invoiceHandler}/>);
                              }
                          }
                          )}
                          </tbody>
                      </table>
                  </div>
              );
              break;
          default:

      }

      return (
        <React.Fragment>
            <Notifications />
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
                {invoice ?
                    <React.Fragment>
                        <header className="quickview-header">
                            <p className="quickview-title lead fw-400">{invoice.description}</p>
                            <span className="close" onClick={this.closeHandler}><i className="ti-close"></i></span>
                        </header>
                        <div className="quickview-body ps-container ps-theme-default">
                            <ModalInvoiceView invoice={invoice} modalBackgroundClicked={this.modalBackgroundClicked} isModal={false}/>
                        </div>
                        <div className="btn-group btn-block btn-group-vertical">
                            <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={()=>this.modalHandler(invoice, ModalInvoiceView , 'View Invoice')}><i className="fa fa-newspaper-o"></i> View</button>
                            <button className={this.state.printing ? "btn btn-lg btn-outline btn-block btn-secondary text-center disabled" : "btn btn-lg btn-outline btn-block btn-secondary"} onClick={()=>this.printInvoice(invoice)}>{this.state.printing ? <div style={{"vertical-align":"middle"}}><div className="spinner-circle-shadow pull-left"></div>Generating your document</div> : <React.Fragment><i className="fa fa-print"></i> Print</React.Fragment>}</button>
                            {invoice.is_published ?
                            <React.Fragment>
                            <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={()=>this.sendPaymentRequest(invoice)}><i className="fa fa-envelope"></i> Send Reminder</button>
                            <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={()=>this.modalHandler(invoice, ModalInvoicePayment, 'Record Payment')}><i className="fa fa-money"></i> Record Payment</button>
                            </React.Fragment>
                            :
                            <React.Fragment>
                            <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={()=>this.invoiceHandler(invoice)}><i className="fa fa-pencil"></i> Edit</button>
                            <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={()=>this.publishHandler(invoice)}><i className="fa fa-external-link-square"></i> Publish</button>
                            </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
                : <div>Loading</div> }
            </div>
            <Modal visible={this.state.visible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg">
                <React.Fragment>
                {this.state.component ? <this.state.component invoice={this.state.invoice} modalBackgroundClicked={this.modalBackgroundClicked} payment_type_list={this.state.payment_type_list} reloadHandler={this.reloadHandler} isModal={true} notifyHandler={notify}/> : null}
                </React.Fragment>
            </Modal>
            {this.state.invoiceComponent ?
                this.state.invoiceComponent
            :
            <React.Fragment>
            <header className="header mb-0">
                <div className="header-action pt-20">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a href="#" className={this.state.activeTab === "unpaid" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('unpaid')}>Unpaid Invoices</a>
                        </li>
                        <li className="nav-item">
                            <a href="#" className={this.state.activeTab === "unpublished" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('unpublished')}>Unpublished Invoices</a>
                        </li>
                        <li className="nav-item">
                            <a href="#" className={this.state.activeTab === "paid" ? "nav-link active" : "nav-link"} onClick={() => this.setActiveTab('paid')}>Paid Invoices</a>
                        </li>
                    </ul>
                </div>
            </header>
            <div className="main-content pt-0">
                <header className="flexbox align-items-center media-list-header bg-transparent b-0 py-16 pl-20">
                    <div className="flexbox align-items-center">
                        <div className="dropdown">
                            <a className="btn btn-sm dropdown-toggle" data-toggle="dropdown" href="#">Sort by</a>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" onClick={() => this.sortBy('PUBLISH')}>Publish Date</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('CREATE')}>Date Created</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('AMOUNT')}>Amount</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="lookup lookup-circle lookup-right">
                            <input type="text" value={this.state.searchValue} onChange={this.valueChange}/>
                        </div>
                        {this.state.searchValue !== '' ? <button className="ml-10 btn btn-outline btn-sm btn-danger" onClick={this.clearSearch}>Clear</button> : null}
                    </div>
                </header>
                <div className="tab-content">
                {isEmpty(original_list) ? <div className="p-30 fs-25 fw-500 text-center">Loading...</div> : isEmpty(invoice_list) ? <div className="p-30 fs-25 fw-500 text-center">No Results</div> : activeTabComponent }
                </div>
            </div>
            </React.Fragment>
            }
        </React.Fragment>
    );
  }
}

export default Invoices;



// WEBPACK FOOTER //
// ./src/components/business/Invoices.js